module.exports = __webpack_public_path__ + "static/walking_statue_of_waterdeep_great_drunkard_wdh-654df0b0409764f1b410cd2dc93599f3.jpeg";